module.exports = {getSkuFromQueryParams: jest.fn()};
